export default __webpack_public_path__ + "static/media/register-artwork-1.9e114217.svg";